import { render, staticRenderFns } from "./RenewConfirmed.vue?vue&type=template&id=2a99b806&"
import script from "./RenewConfirmed.vue?vue&type=script&lang=js&"
export * from "./RenewConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./RenewConfirmed.vue?vue&type=style&index=0&id=2a99b806&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports